import api from 'api';

export const loadCampaigns = api('POST /api/campaigns/grid');
export const createCampaign = api('POST /api/campaigns');
export const createDummyCampaign = api('POST /api/spend-adjustments/campaign');
export const loadMediaSource = api('GET /api/campaigns/isMissingMediaSource');

export const editCampaign = api('PUT /api/campaigns/:id');
export const loadCampaign = api('GET /api/campaigns/:id');
export const loadCampaignDetails = api('GET /api/campaigns/:id/details');

export const loadCostModel = api(
  'GET /api/campaigns/:campaignId/cost-models/:id'
);
export const editCostModel = api(
  'PUT /api/campaigns/:campaignId/cost-models/:id'
);

export const changeOwners = api('PUT /api/campaigns/owners-bulk');
export const changeOwnersStatus = api(
  'GET /api/campaigns/owners-bulk/:jobId/status'
);
export const exportCampaigns = api('POST /api/campaigns/export', {
  responseType: 'blob',
});
export const changeCampaignsStatus = api('PUT /api/campaigns/statuses-bulk');
export const campaignsStatusConfirmation = api(
  'POST /api/campaigns/statuses-confirmation'
);
export const addPromoCode = api('PUT /api/campaigns/bulk/:id/add-promocode');
export const loadPromoCodesBulk = api('POST /api/campaigns/promo-codes');

export const uploadNewCampaigns = api('POST /api/campaigns/upload/csv');
export const uploadUploadedCampaigns = api('POST /api/campaigns/upload/csv');

export const getUploadErrors = api(
  'GET /api/campaigns/upload/csv/:jobId/errors'
);

export const checkUploadCampaigns = api(
  'GET /api/campaigns/upload/csv/:jobId/status'
);

export const createMediaSource = api('POST /api/campaigns/media-sources');
